import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import '../Pagination.css';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import { createPagedGridController } from '../../hooks/pagedGridClassAdapter';
import * as actasService from '../../services/actas/actasService';
import { classifyActasError, formatActaCursadaResultadoDisplay } from '../../services/actas/actasDto';

export class VerActaCursada extends Component {
  static displayName = VerActaCursada.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      perPage: 10,
      paginationData: [],
      pageCount: 1,
      forcePage: 0,
      showErrorMessage: false,
      errorMessage: '',
      materia: '',
      id: this.props.match.params.id
    };
    this.grid = createPagedGridController({
      fetchPage: (query) => actasService.listActaCursadaDetalle(this.state.id, query),
      defaultPageSize: 10,
      onChange: (gridState) => this.applyGridState(gridState)
    });
    this.handleStatus = this.handleStatus.bind(this);
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWActasCursado');
    if (canAccess) {
      this.populateData();
    }
  }

  applyGridState(gridState) {
    this.setState({
      paginationData: gridState.items,
      pageCount: gridState.pageCount,
      perPage: gridState.pageSize,
      loading: gridState.loading,
      forcePage: gridState.forcePage
    });
  }

  handlePageClick = (e) => {
    this.grid.handlePageClick(e).catch((error) => this.handleActasError(error));
  };

  handleStatus = (resultado) => formatActaCursadaResultadoDisplay(resultado);

  renderalumnosTable(alumnos) {
    if (!alumnos.length) {
      return (
        <div className="md-page__table-card">
          <p className="md-page__empty-state">Sin alumnos en el acta</p>
        </div>
      );
    }

    return (
      <div className="md-page__table-card">
        <table className="md-page__table" aria-labelledby="ver-acta-cursada-title">
          <thead>
            <tr>
              <th scope="col">DNI</th>
              <th scope="col">Nombre y Apellido</th>
              <th scope="col">Resultado</th>
            </tr>
          </thead>
          <tbody>
            {alumnos.map(alumno =>
              <tr key={alumno.detalleActaCursadaCod}>
                <td>{alumno.alumnoDni}</td>
                <td>{alumno.alumnoNombre}</td>
                <td>{this.handleStatus(alumno.detalleActaCursadaResultado)}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const listLoading = this.state.loading && this.state.paginationData.length === 0;
    let contents = listLoading
      ? <p className="md-page__loading"><em>Cargando datos...</em></p>
      : this.renderalumnosTable(this.state.paginationData);

    const materiaDisplay = this.state.materia.trim();

    return (
      <div className="md-page md-ver-acta-cursada">
        <Link className="md-page__back-link" to="/md-acur">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 id="ver-acta-cursada-title" className="md-page__title">Ver Acta de Cursada</h1>
        </div>
        <p className="md-page__subtitle">
          Consulte los resultados cargados para cada alumno del acta.
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field md-page__field--inline-readonly">
            <span className="md-page__field-label">Materia</span>
            <div
              className="md-page__field-readonly md-page__field-readonly--single-line"
              title={materiaDisplay}
            >
              {materiaDisplay}
            </div>
          </div>
        </div>

        {contents}

        {!this.state.loading && this.state.pageCount > 1 ? (
          <div className="md-page__pagination">
            <ReactPaginate
              previousLabel="Anterior"
              nextLabel="Siguiente"
              breakLabel="..."
              pageCount={this.state.pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={this.handlePageClick}
              forcePage={this.state.forcePage}
              containerClassName="pagination"
              activeClassName="active"
            />
          </div>
        ) : null}
      </div>
    );
  }

  handleActasError(error) {
    const outcome = classifyActasError(error);
    if (outcome.type === 'timeout') {
      constantClass.RedirectToLogin();
      return;
    }
    this.setState({
      showErrorMessage: true,
      errorMessage: outcome.message,
      loading: false
    });
  }

  async populateData() {
    try {
      actasService.clearActaCursadaDetalleCache(this.state.id);
      const returnModel = await actasService.getActaCursadaDetalle(this.state.id);
      actasService.seedActaCursadaDetalleCache(this.state.id, returnModel);
      const materia = returnModel.length > 0
        ? `${returnModel[0].materiaCarreraNombre.trim()} - ${returnModel[0].carreraNombre.trim()}`
        : '';
      this.setState({ materia });
      await this.grid.load();
    } catch (error) {
      this.handleActasError(error);
    }
  }
}
